export const convertReputationToLevel = (reputationBet: number): string => {
  const fixedReputationBet = Number(reputationBet.toFixed(1));
  return fixedReputationBet < 1.1
    ? 'Low'
    : fixedReputationBet < 2.1
      ? 'Medium'
      : 'High';
};
